import TableHeader from '@tiptap/extension-table-header';
import { findParentNodeOfType } from 'prosemirror-utils';

import { preventNewLinesInsideTable } from './shared';

export default TableHeader.extend({
  addProseMirrorPlugins() {
    return [preventNewLinesInsideTable('table-header')];
  },
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const { state, commands } = editor;

        if (!findParentNodeOfType(state.schema.nodes.tableHeader)(state.selection)) {
          return false;
        }

        commands.setHardBreak();

        return true;
      },
    };
  },
});
